import { useCallback } from "react";
import { KanjiDrawCounts } from "../utils/kanjiDrawCountsStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useKanjiDrawCounts() {
    const { data: counts, update, syncStatus } = useDeviceProgress<KanjiDrawCounts>("kanjiDrawCounts", true);
    const increment = useCallback((key: string) => { void update({ kind: "increment", key }); }, [update]);
    return { counts, increment, syncStatus };
}
